
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/business",
      function () {
        return require("private-next-pages/partners/business/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/business"])
      });
    }
  